import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const CampusConduct = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Conduct At Campus</h1>
      <hr />
      {/* ---------- Accordion 1 ---------- */}
      <Accordion
        title="Sailing forward with new skills"
        isActive={activeIndex === 0}
        onClick={() => handleToggle(0)}
      />
      {activeIndex === 0 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">
            MANET Rules and Regulations- General Discipline
          </h4>
          <ul className="page-content-lists">
            <li>
              The cadets must always be in uniforms. The uniform must be clean
              and ironed.
            </li>
            <li>
              Uniform: The cadets must buy 2 sets of shirts and trousers, once
              in two years i.e. at the end of 2nd year on payment.
            </li>
          </ul>

          <h4 className="innerpage-subheading">Uniform Guidelines:</h4>
          <ul className="page-content-lists">
            <li>Shirt - white color (Clean, especially collar)</li>
            <li>Trousers - Black color with pleats.</li>
            <li>
              Trouser should be worn in such a way that the trouser belt should
              be one inch below the crease{" "}
            </li>
            <li>Epaulette - Button well-polished</li>
            <li>
              "Name tag" should be visible easily and "collar tag" to be well
              polished.
            </li>
            <li>Belt with crest polished and tightly worn.</li>
            <li>
              Leather oxford style black shoes well-polished with black socks.
            </li>
            <li>Peak cap with clean crest.</li>
            <li>Hair cut - Short without side locks</li>
            <li>Properly shaved.</li>
            <li>
              Ship-in-campus and Workshops: Light blue color Boiler suit,
              Black-Color safety shoes, and wearing of helmet is compulsory.
            </li>
            <li>
              It is compulsory for all cadets to take part in physical training,
              indoor and outdoor games, swimming, parade, and other
              co-curricular activities.
            </li>
            <li>
              The cadets will be clean-shaven, except for the cadets belonging
              to Sikhism. The hair and mustaches will be properly trimmed for
              'Officer like' appearance.
            </li>
            <li>
              Cadets are not permitted to carry mobile phones to the
              administrative block. If any cadet is found with mobile phones in
              the administrative block, it will be immediately confiscated, and
              cadet is liable for disciplinary action.
            </li>
            <li>
              Cadets must carry out all written and verbal orders of authorities
              and rank holders (leading cadets) promptly, without any argument.
            </li>
            <li>
              Cadets will not leave the hostel without prior permission.
              Unauthorized absence from the hostel will be dealt with severely
              and may result in suspension from the institute.
            </li>
            <li>
              Attendance in classes and workshops is compulsory. Under no
              circumstances will the cadet abstain himself from
              classes/workshops without prior permission from concerned
              authorities (Principal/Vice- principal/Warden).
            </li>
            <li>
              Smoking and consumption of alcohol, tobacco, or drugs is strictly
              prohibited inside the campus. Strict disciplinary action will be
              taken against the cadets indulging in these activities which may
              result in expulsion of the cadet from the institute
            </li>
          </ul>
        </div>
      )}

      {/* ---------- Accordion 2 ---------- */}
      <Accordion
        title="Enthusiastic participations in events & celebrations"
        isActive={activeIndex === 1}
        onClick={() => handleToggle(1)}
      />
      {activeIndex === 1 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Hostel Discipline</h4>
          <ul className="page-content-lists">
            <li>
              Cadets must not keep large amounts of cash in their possessions or
              in hostel.
            </li>
            <li>
              Cadets must always remain in hostel in proper uniform. They are
              not to loiter in towels or sleeping suits.
            </li>
            <li>
              Cadets cannot bring any type of vehicle (two or four-wheelers)
              inside the premises of the institute.
            </li>
            <li>
              Cadets will use the recreation room etc. only at specified time as
              instructed by wardens on duty.
            </li>
            <li>
              Cadets will take their meals/tea etc. in the dining hall and
              during specified timings only.
            </li>
            <li>
              Application for exemption from any activity on medical grounds
              must be supported by medical officer's certificate.
            </li>
            <li>
              Cadets are liable for disciplinary action for being absent from
              hostel routine, dressed improperly and for in-disciplinary
              activities.
            </li>
            <li>
              Lights in the hostel rooms are to be switched off at 2230Hrs.
              daily.
            </li>
            <li>
              Stay of Guests or relatives in hostel rooms is strictly
              prohibited.
            </li>
            <li>
              Cadets will meet their guests in the warden's office on the ground
              floor and normally between 1700Hrs. to 1900Hrs. Cadets having
              unauthorized guests or guests coming at odd hours will be dealt
              with as per the rules.
            </li>
          </ul>
        </div>
      )}

      {/* ---------- Accordion 3 ---------- */}
      <Accordion
        title="Role of holistic development & skills"
        isActive={activeIndex === 2}
        onClick={() => handleToggle(2)}
      />
      {activeIndex === 2 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">
            Institute Rules for awarding various punishments
          </h4>
          {/* ===== Scholarship Table ===== */}
          <div className="page-content-table-wrapper">
            <table className="page-content-table " style={{ width: "95%" }}>
              <thead>
                <tr>
                  <th>Sr. No. </th>
                  <th>Offence </th>
                  <th>Punishment</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Bursting Of Crackers in the Hostel </td>
                  <td>Fine Of Rs. 2500/- And 01 Week Suspension</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Caught While Giving Proxy Attendance </td>
                  <td>01 Week Suspension</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Bursting Of Crackers in the Hostel </td>
                  <td>Fine Of Rs. 2500/- And 01 Week Suspension</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>
                    Mass Bunking of the Class/ Practical/ Hostel Routine (10 Or
                    More Cadets Absent)
                  </td>
                  <td>
                    01 Week Suspension for The Defaulting Cadets (Post Facto
                    Excuses of Any Kind Will Not Be Entertained)
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>
                    Absent In Any Muster. (Class, Night, PT, Parade, Band){" "}
                  </td>
                  <td className="vertical-cell">
                    1st Offence - Verbal Warning
                    <br />
                    2nd Offence - Written Warning
                    <br />
                    3rd Offence - 01 Day Suspension
                    <br />
                    4th Offence-02 Days Suspension
                    <br />
                    5th And Every Repeat Offence - 03 Days Suspension{" "}
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>Absent From Hostel Without Permission </td>
                  <td className="vertical-cell">
                    Maximum: 01 Week Suspension from Hostel
                    <br />
                    Minimum: Rs. 250/- Per Day For 1/2 Times the Number of the
                    Days Absent Without Permission Round Off to the Next
                    Complete Day.
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>
                    Going On Vacation Without Following Check Out Procedure{" "}
                  </td>
                  <td className="vertical-cell">
                    1st Offence - Fine of Rs.2000/- Per Day and Defaulting
                    Cadets Will Be Barred From 1st Placement Interview.
                    <br />
                    2nd Offence - Fine of Rs.2500/- Per Day and Defaulting
                    Cadets Will Be Barred From 1st & 2nd Placement Interview.
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>Reporting Late From Vacation Leave </td>
                  <td className="vertical-cell">
                    1st Offence - Fine of Rs.2000/- Per Day and Defaulting
                    Cadets Will Be Barred From 1st Placement Interview.
                    <br />
                    2nd Offence - Fine of Rs.2500/- Per Day and Defaulting
                    Cadets Will Be Barred From 1st & 2nd Placement Interview.
                  </td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>
                    Wearing Improper Uniform/ Bad Turn Out (Including Long Hair,
                    No Shaving, Unpolished Shoes Etc.) In College/ Dining Hall
                  </td>
                  <td className="vertical-cell">
                    1st Offence - Verbal Warning
                    <br />
                    2nd Offence - Written Warning
                    <br />
                    3rd Offence-01 Day Suspension
                    <br />
                    4th Offence-02 Days Suspension
                    <br />
                    5th And Every Repeat Offence - 03 Day Suspension
                  </td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>Bed, Wardrobe, Room Dirty/ Disarranged </td>
                  <td className="vertical-cell">
                    1st Offence - Verbal Warning
                    <br />
                    2nd Offence - Written Warning Plus 01 Day Suspension
                    <br />
                    3rd Offence-02 Day Suspension
                    <br />
                    4th Offence-03 Days Suspension
                    <br />
                    5th And Every Repeat Offence - 01 Week Suspension
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ---------- Accordion 4 ---------- */}
      <Accordion
        title="Enthusiastic participations in events & celebrations"
        isActive={activeIndex === 3}
        onClick={() => handleToggle(3)}
      />
      {activeIndex === 3 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">Leave Rules</h4>
          <ul className="page-content-lists">
            <li>
              Cadets are granted leave during periods of vacation which are
              declared by the institute.
            </li>
            <li>
              A cadet is liable for disciplinary action if he reports back late
              from home leave, city leave, night off etc.{" "}
            </li>
            <li>
              Cadets absent/away from training more than the permitted leave on
              whatsoever grounds may be debarred from appearing in examinations
              or may be removed from training on disciplinary grounds.
            </li>
            <li>
              Cadets may be granted leave on recommendation of the medical
              officer. A maximum of 15 days medical leave is permitted per
              academic year on producing proper medical certificate.
            </li>
            <li>
              A maximum of 5 night-offs are permitted in one semester after
              obtaining written permission in advance from the concerned
              authorities.
            </li>
            <li>
              All applications must be addressed to the Head of Hostel and
              forwarded through hostel warden.
            </li>
            <li>
              In the interpretation of these rules, the principal’s decision
              will be final.
            </li>
            <p className="page-content-note">
              <b>Note :</b> Ragging on campus is strictly prohibited. An
              incidence of ragging is immediately acted upon and guilty is
              liable to be dismissed from the Institute.
            </p>
          </ul>
        </div>
      )}

      {/* ---------- Accordion 5 ---------- */}
      <Accordion
        title="Role of holistic development & skills"
        isActive={activeIndex === 4}
        onClick={() => handleToggle(4)}
      />
      {activeIndex === 4 && (
        <div className="accordion-content">
          <h4 className="innerpage-subheading">
            Policy on prevention of drug and alcohol abuse
          </h4>

          <p id="page-links">
            Policy on prevention of drug and alcohol abuse
            <a href="https://manetpune.edu.in/assets_web/pdf/Prevention_of_drug_and_alcohol_abuse.pdf" target="_blank" rel="noopener noreferrer">
              <button>Click Here</button>
            </a>
          </p>

          <p id="page-links">
            Notice on ban of Drugs and Alcohol at MANET
            <a href="https://manetpune.edu.in/assets_web/pdf/Notice_on_ban_of_Drugs_and_Alcohol_at_MANET.pdf" target="_blank" rel="noopener noreferrer">
              <button>Click Here</button>
            </a>
          </p>

        </div>
      )}
    </div>
  );
};

export default CampusConduct;
